import { useBackerApi } from '@givebacks/api/backer';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useBackerInfo() {
  const BackerApi = useBackerApi();
  const getBacker = async () => {
    const { data } = await BackerApi.get('/backers/me');
    return data.backer;
  };
  return useQuery({
    queryKey: ['backer', 'backers', 'me'],
    queryFn: getBacker,
  });
}

export function useUpdateBacker() {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const editUser = async (backer: { [type: string]: string | boolean }) => {
    const { data } = await BackerApi.put(`/backers`, backer);
    return data;
  };

  return useMutation({
    mutationFn: editUser, // On success data returns the data from the mutation. AKA the new user object.
    onSuccess(data) {
      // We use onSuccess here to handle mutation specific concerns
      // queryClient.invalidateQueries(["user"]);
      const backer = data?.backer;
      // To-do: This actually removes the user session since it is not included in the edit user info api response.
      queryClient.setQueryData(['backer', 'backers', 'me'], (prev: any) => ({
        ...prev,
        ...backer,
      }));
    },
  });
}
